import React from "react";
import { Formik, Field } from "formik";
import { connect } from "react-redux";
import { Col, Row, FormGroup, Label } from "reactstrap";
import { Button } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import schema from "./schema";
import DropDownMenu from "../../../../components/form/DropDownMenu";
import InputField from "../../../../components/form/InputField";

import { signupCustomerAction } from "../../../../modules/auth/Actions";
import { authIsLoadingSelector } from "../../../../modules/auth/Selectors";
import { CheckBox } from "../../../../components/form";

const CustomerOptions = [
	{ value: "0", label: "Individual" },
	{ value: "1", label: "Company" },
];

function CustomerRegistration(props) {
	// added render={()=>} instead of component in every <Field />

	const { intl, signupCustomer, authIsLoading } = props;
	return (
		<div className="kt-login__body">
			<div className="kt-login__form">
				<div className="kt-login__title">
					<h3>
						<FormattedMessage id="AUTH.REGISTER_CUSTOMER.TITLE" />
					</h3>
				</div>

				<Formik
					initialValues={{
						firstName: "",
						lastName: "",
						password: "",
						email: "",
						country: "",
						province: "",
						phone: "",
						zipCode: "",
						address: "",
						city: "",
						businessName: "",
						userType: ["4"],
						customerType: ["0"],
						yearEstablished: "",
						reqCompany: false,
					}}
					validationSchema={schema(intl)}
					onSubmit={async (values, { setStatus, setSubmitting }) => {
						const requet = await signupCustomer(values);
					}}
				>
					{({
						values,
						status,
						errors,
						touched,
						handleChange,
						handleBlur,
						handleSubmit,
						isSubmitting,
						setFieldValue,
						setFieldTouched,
					}) => (
						<>
							<form className="kt-form" onSubmit={handleSubmit}>
								<Row form>
									<Col md={6}>
										<FormGroup>
											<Label for="firstName">
												{/* First Name */}
												<FormattedMessage id="AUTH.REGISTER_FIRST.NAME" />
											</Label>
											<Field
												type="text"
												name="firstName"
												id="firstName"
												placeholder="First Name"
												render={() => <InputField name="firstName" />}
											/>
										</FormGroup>
									</Col>

									<Col md={6}>
										<FormGroup>
											<Label for="lastname">
												{/* Last Name */}
												<FormattedMessage id="AUTH.REGISTER_LAST.NAME" />
											</Label>
											<Field
												type="text"
												name="lastName"
												id="lastname"
												placeholder="Last Name"
												render={() => <InputField name="lastName" />}
											/>
										</FormGroup>
									</Col>
								</Row>

								<FormGroup>
									<Label for="email">
										{/* Email */}
										<FormattedMessage id="AUTH.REGISTER_EMAIL" />
									</Label>
									<Field
										type="text"
										name="email"
										id="email"
										placeholder="Enter Your Email"
										render={() => <InputField name="email" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="password">
										{/* Password */}
										<FormattedMessage id="AUTH.REGISTER_PASSWORD" />
									</Label>
									<Field
										type="password"
										name="password"
										id="password"
										placeholder="Enter Your Password"
										render={() => (
											<InputField name="password" type="password" />
										)}
									/>
								</FormGroup>
								<hr />
								<FormGroup>
									<Label for="city">
										{/* Country */}
										<FormattedMessage id="AUTH.REGISTER_COUNTRY" />
									</Label>
									<Field
										type="text"
										name="country"
										id="country"
										placeholder="Enter Your Country"
										render={() => <InputField name="country" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="address">
										{/* Address */}
										<FormattedMessage id="AUTH.REGISTER_ADDRESS" />
									</Label>
									<Field
										type="text"
										name="address"
										id="address"
										placeholder="Enter Your address"
										render={() => <InputField name="address" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="province">
										{/* Province */}
										<FormattedMessage id="AUTH.REGISTER_PROVINCE" />
									</Label>
									<Field
										type="text"
										name="province"
										id="province"
										placeholder="Enter Your province"
										render={() => <InputField name="province" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="city">
										{/* City */}
										<FormattedMessage id="AUTH.REGISTER_CITY" />
									</Label>
									<Field
										type="text"
										name="city"
										id="city"
										placeholder="Enter Your city"
										render={() => <InputField name="city" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="phone">
										{/* Phone */}
										<FormattedMessage id="AUTH.REGISTER_PHONE" />
									</Label>
									<Field
										type="text"
										name="phone"
										id="phone"
										placeholder="Enter Your phone"
										render={() => <InputField name="phone" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="zipCode">
										{/* Zip Code */}
										<FormattedMessage id="AUTH.REGISTER_ZIPCODE" />
									</Label>
									<Field
										type="text"
										name="zipCode"
										id="zipCode"
										placeholder="Enter Your zip Code"
										render={() => <InputField name="zipCode" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="customerType">
										{/* Customer Type */}
										<FormattedMessage id="AUTH.REGISTER_CUSTOMER.TYPE" />
									</Label>
									<DropDownMenu
										options={CustomerOptions}
										name="customerType"
										value={values.customerType}
										onChange={setFieldValue}
										onBlur={setFieldTouched}
										error={errors.customerType}
										touched={touched.customerType}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="businessName">
										{/* Business Name */}
										<FormattedMessage id="AUTH.REGISTER_BUSINESS.NAME" />
									</Label>
									<Field
										type="businessName"
										name="businessName"
										id="businessName"
										placeholder="Enter Your business Name"
										render={() => <InputField name="businessName" />}
									/>
								</FormGroup>
								<FormGroup>
									<Label for="yearEstablished">
										{/* Year Established */}
										<FormattedMessage id="AUTH.REGISTER_YEAR.ESTABLISHED" />
									</Label>
									<Field
										type="yearEstablished"
										name="yearEstablished"
										id="yearEstablished"
										placeholder="Year Established"
										render={() => <InputField name="yearEstablished" />}
									/>
								</FormGroup>

								<CheckBox
									name="reqCompany"
									label="reqCompany"
									subLabel="reqCompany"
								/>

								<div
									className="kt-login__actions"
									style={{ display: "flex", flexDirection: "row-reverse" }}
								>
									<Button disabled={authIsLoading} type="submit">
										{authIsLoading ? "loading ..." : "Sign Up"}
									</Button>
								</div>
							</form>

							{/* <div  USELESSDEV
                style={{
                  position: 'fixed',
                  width: '300px',
                  height: '400px',
                  left: '20px',
                  top: '20px',
                  backgroundColor: '#fff',
                  color: '#000',
                }}
              ></div> */}
						</>
					)}
				</Formik>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	authIsLoading: authIsLoadingSelector(state),
});

export default injectIntl(
	connect(mapStateToProps, { signupCustomer: signupCustomerAction })(
		CustomerRegistration
	)
);
